export enum OrderTypeEnum {
  counter = 'counter',
  kiosk = 'kiosk',
  delivery = 'delivery',
  table = 'table',
  ticket = 'ticket',
  driveThru = 'driveThru',
  manual = 'manual',
  totem = 'totem',
  other = 'other',
}

export const FormattedOrderTypeEnum: Record<OrderTypeEnum, string> = {
  counter: 'Balcão',
  kiosk: 'Quiosque',
  delivery: 'Delivery',
  driveThru: 'Drive thru',
  manual: 'Digitada',
  other: 'Outro',
  table: 'Mesa',
  ticket: 'Comanda',
  totem: 'Totem',
};
